/** Apply presentation width to a detached SVG copy; never alter source artifacts. */
export function applyAssetPlanStrokeFactor(root, value = 1) {
  const factor = Math.min(20, Math.max(0.1, Number(value) || 1));
  if (!root || factor === 1) return;
  const visit = (node, inherited = '1') => {
    const width = node.style?.getPropertyValue('stroke-width') || node.getAttribute?.('stroke-width') || inherited;
    // Preserve units and inheritance. Resolve before changing the parent so a
    // child never receives the factor twice.
    for (const child of node.children || []) visit(child, width);
    if (!/^(path|line|polyline|polygon|rect|circle|ellipse)$/i.test(node.tagName || '')) return;
    const match = /^([\d.eE+-]+)(px|mm|cm|in|pt|pc)?$/.exec(String(width).trim());
    if (!match || !Number.isFinite(Number(match[1]))) return;
    const scaled = `${Number(match[1]) * factor}${match[2] || ''}`;
    node.setAttribute('stroke-width', scaled);
    if (node.style?.getPropertyValue('stroke-width')) node.style.setProperty('stroke-width', scaled);
  };
  visit(root);
}
